// extracted by mini-css-extract-plugin
export default {"indicatorIcon":"emailVerfication_indicatorIcon__8VSX9","slide":"emailVerfication_slide__K1jNm"};